import { useEffect, useRef } from "react";
import { ImageProps } from "../image/image";
import Image from "../image/image";
import styles from "./fade-in-image-effect.module.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export interface FadeInImageEffectProps extends ImageProps {
  containerAnimation?: gsap.core.Animation;
}
const FadeInImageEffect = (props: FadeInImageEffectProps) => {
  const ctnRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const ctx = gsap.context(() => {
      ScrollTrigger.matchMedia({
        "(min-width: 1024px)": function () {
          gsap.fromTo(
            ctnRef.current,
            {
              "--fade-in-image-y": "100%",
            },
            {
              "--fade-in-image-y": "0%",
              duration: 0.8,
              ease: "power4.out",
              onComplete: () => {
                if (ctnRef.current)
                  ctnRef.current.style.backgroundColor = "black";
              },
              scrollTrigger: {
                trigger: ctnRef.current,
                start: "left 80%",
                containerAnimation: props.containerAnimation,
              },
            }
          );
        },
        "(max-width: 1023px)": function () {
          gsap.fromTo(
            ctnRef.current,
            {
              "--fade-in-image-y": "100%",
            },
            {
              "--fade-in-image-y": "0%",
              duration: 0.8,
              ease: "power4.out",
              onComplete: () => {
                if (ctnRef.current)
                  ctnRef.current.style.backgroundColor = "black";
              },
              scrollTrigger: {
                trigger: ctnRef.current,
                start: "top 80%",
              },
            }
          );
        },
      });
    });

    return () => ctx.revert();
  }, [props.containerAnimation]);
  return (
    <div
      className={`${props.className} ${styles.ctn}`}
      style={props.style}
      ref={ctnRef}
    >
      <Image {...props} className={`${props.className} ${styles.image}`} />
    </div>
  );
};
export default FadeInImageEffect;
